import React from 'react';
import { Navigate } from 'react-router-dom';

const decodeJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
};

const isTokenExpired = (token) => {
  const payload = decodeJwt(token);
  if (!payload) return true;
  return payload.exp * 1000 < Date.now();
};

// A token is "MFA-verified" if its mfa claim is "verified", OR if there is
// no mfa claim at all (backward compat for tokens issued before the 2FA
// enforcement change). Pre-MFA tokens explicitly carry mfa: "pending" and
// must NOT pass this check — we bounce those to /2fa to complete verification.
const isMfaVerified = (token) => {
  const payload = decodeJwt(token);
  if (!payload) return false;
  return !payload.mfa || payload.mfa === 'verified';
};

const clearAuthData = () => {
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('userAccessLevel');
  localStorage.removeItem('isAdmin');
  localStorage.removeItem('isOwner');
};

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  const token = localStorage.getItem('jwtToken');

  if (!isLoggedIn || !token || isTokenExpired(token)) {
    clearAuthData();
    return <Navigate to="/" replace />;
  }

  // The MFA-verified check is now driven by the JWT claim, NOT by a
  // localStorage flag. This prevents a stale "is2FAVerified" flag from a
  // previous session from letting a pre-MFA token reach protected routes.
  if (!isMfaVerified(token)) {
    return <Navigate to="/2fa" replace />;
  }

  return children;
};

export default ProtectedRoute;
